import { Alert, Box } from "@mui/material";
import { useTranslate } from "react-admin";

import type { SalesforceReportSectionFragment, SalesforceReportUnavailable } from "../generated/graphql";

type Coverage = Partial<Pick<SalesforceReportSectionFragment, "unreadableFields" | "missingFields" | "pendingObjects">>;

export const ReportCoverageWarnings = ({
  unreadableFields = [],
  missingFields = [],
  pendingObjects = [],
}: Coverage) => {
  const translate = useTranslate();
  return (
    <Box
      sx={{
        display: "grid",
        gap: 1,
        mb: unreadableFields.length || missingFields.length || pendingObjects.length ? 2 : 0,
      }}
    >
      {unreadableFields.length > 0 && (
        <Alert severity="warning">
          {translate("salesforceReports.unreadableFields", { fields: unreadableFields.join(", ") })}
        </Alert>
      )}
      {missingFields.length > 0 && (
        <Alert severity="warning">
          {translate("salesforceReports.missingFields", { fields: missingFields.join(", ") })}
        </Alert>
      )}
      {pendingObjects.length > 0 && (
        <Alert severity="info">
          {translate("salesforceReports.pendingObjects", {
            objects: pendingObjects
              .map(object => translate(`salesforceReports.objects.${object}`, { _: object }))
              .join(", "),
          })}
        </Alert>
      )}
    </Box>
  );
};

export const ReportUnavailable = ({ reason }: { reason: SalesforceReportUnavailable }) => {
  const translate = useTranslate();
  return <Alert severity="info">{translate(`salesforceReports.unavailable.${reason}`)}</Alert>;
};
